import { render, staticRenderFns } from "./Func51Novo.vue?vue&type=template&id=3b8def34&scoped=true"
import script from "./Func51Novo.vue?vue&type=script&lang=js"
export * from "./Func51Novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8def34",
  null
  
)

export default component.exports